import { HISTORY_ACTION_MODE } from '@candulabs/craft';

export enum SizeType {
  Pixel = 'pixel',
  Percentage = 'percentage',
  Auto = 'auto',
  Default = 'default',
}

export enum CssProp {
  Width = 'width',
  Height = 'height',
}

export type SizeValue = number | SizeType.Default | undefined;

export interface Size {
  [CssProp.Width]: { type: SizeType; value?: SizeValue };
  [CssProp.Height]: { type: SizeType; value?: SizeValue };
}

export const defaultSize: Size = {
  [CssProp.Width]: { type: SizeType.Default, value: undefined },
  [CssProp.Height]: { type: SizeType.Default, value: undefined },
};

export interface ResponsiveSize {
  normal: Size;
  min: Size;
  max: Size;
}

export type SetSize = (
  size: Size,
  historyMode?: HISTORY_ACTION_MODE,
  throttleNumber?: number,
) => void;
